//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "market-price-detail",
  data(){
    return{
      dto:{},
      marketId:null,
      selectModel:'base',
      priceList:[],
      page:0,
      moreBol:true
    }
  },
  methods:{
    backLast(){
      this.$router.go(-1);
    },
    changeShowModel(str){
      this.selectModel = str;
      if(str === 'price'){
        this.page = 0;
        this.priceList = [];
        this.getPriceList();
      }
    },
    getDto(){
      this.$loadingShow();
      this.$get(`api/marketPrice/${this.marketId}`).then((res) => {
        if(res){
          this.dto = res;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getPriceList(){
      let obj = {
        number:this.page,
        size:20,
        rules: [{field: "marketPriceId", option: "EQ", values: [this.marketId],direction: "DESC",property: "getTime"}]
      };
      this.$loadingShow();
      this.$post('api/marketPriceDataLog/page',obj).then((res) => {
        if(res && res.content){
          this.priceList = [...this.priceList,...res.content];
          if(res.content.length < 20){
            this.moreBol = false;
          }else{
            this.moreBol = true;
          }
        }else{
          this.moreBol = false;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    showMore(){
      this.page++;
      this.getPriceList();
    },
    updatePrice(){
      this.$loadingShow();
      this.$get(`api/marketPriceDataLog/manualGetByMarketPriceId/${this.marketId}`).then((res) => {
        this.$loadingHide();
        this.page = 0;
        this.priceList = [];
        this.getPriceList();
      }).catch(() => {
        this.$loadingHide();
      })
    }
  },
  mounted(){
    this.marketId = this.$route.params.id;
    this.getDto();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/market-price/market-price-detail.vue